import type { TLGroupShape } from "@tldraw/tlschema";
import { Box } from "../../geometry";
import { Rectangle2d } from "../geometry2d";
import { ShapeUtil } from "../shape-util";
import type { CanvasEditor } from "../editor";

// Groups have no body of their own; their bounds wrap their children.

export class GroupShapeUtil extends ShapeUtil<TLGroupShape> {
  static override type = "group";
  getDefaultProps(): TLGroupShape["props"] {
    return {};
  }
  getGeometry(shape: TLGroupShape) {
    const editor = this.editor as unknown as CanvasEditor;
    const boxes = editor.getSortedChildIdsForParent(shape.id).map((id) => {
      const child = editor.getShape(id)!;
      const toGroup = editor
        .getShapePageTransform(shape)
        .invert()
        .multiply(editor.getShapePageTransform(child));
      return toGroup.applyToBounds(editor.getShapeGeometry(child).bounds);
    });
    const b = boxes.length ? Box.Common(boxes) : new Box(0, 0, 1, 1);
    return new Rectangle2d({
      x: b.x,
      y: b.y,
      width: Math.max(1, b.w),
      height: Math.max(1, b.h),
      isFilled: false,
    });
  }
  override canResize() {
    return false;
  }
  override hideRotateHandle() {
    return true;
  }
  component() {
    return null;
  }
  /** Children export themselves. */
  toSvg() {
    return null;
  }
}
